import React from "react";

const FilledButton = ({
  text,
  textColor = "#ffffff",
  backgroundColor = "#5153F5",
  onPress,
  icon = null,
  marginBottom = 0,
  marginTop = 0,
}) => {
  return (
    <>
      <div
        onClick={onPress}
        className="cursor-pointer w-full rounded-full p-2 flex flex-row justify-center items-center"
        style={{
          backgroundColor: backgroundColor,
          marginBottom: marginBottom,
          marginTop: marginTop,
        }}
      >
        {icon}
        <p
          className="text-base text-center font-medium"
          style={{ color: textColor }}
        >
          {text}
        </p>
      </div>
    </>
  );
};

export default FilledButton;
